import { query, waitForAllReturnWhenError } from '@confluence/query-preloader-tools';
import { preloadWebItemLocation } from '@confluence/web-item-location/entry-points/preloadWebItemLocation';

import { AppNavigationUnifiedQuery } from './AppNavigationUnifiedQuery.graphql';

export function preloadAppNavigation() {
	return waitForAllReturnWhenError([
		query({
			query: AppNavigationUnifiedQuery,
		}),
		preloadWebItemLocation({
			location: 'system.header/left',
		}),
	]);
}
